import { tickerItems } from '@/mocks/home';

export default function NoticeTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <section className="w-full border-y border-background-200 bg-background-100">
      <div className="max-w-[1400px] mx-auto flex items-center gap-0 h-12 md:h-14">
        <div className="shrink-0 h-full px-4 md:px-6 flex items-center gap-2 bg-primary-500 text-background-50">
          <i className="ri-live-line text-base animate-pulse" />
          <span className="text-xs md:text-sm font-bold whitespace-nowrap">实时开聊</span>
        </div>
        <div className="flex-1 overflow-hidden">
          <div className="marquee-track">
            {loop.map((item, index) => (
              <span key={`${item}-${index}`} className="flex items-center gap-2 px-6 text-xs md:text-sm text-foreground-700 whitespace-nowrap">
                <i className="ri-chat-smile-2-line text-secondary-600" />
                {item}
                <span className="text-background-400 ml-4">/</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}